import { devices } from '@src/styles/theme';
import styled from 'styled-components';

type Props = {
  name: string;
  title: string;
  content: string;
  reNewCount: number;
  blood: string;
  donationType: string;
};

const DonationCard = ({
  name,
  title,
  content,
  reNewCount,
  blood,
  donationType,
}: Props) => {
  return (
    <Container>
      <Name>{name}</Name>
      <Title>{title}</Title>
      <Content>{content}</Content>
      <Flex>
        <ReNewButton>사연연장 {reNewCount}회</ReNewButton>
        <InfoButton>{blood}+</InfoButton>
        <InfoButton>{donationType}</InfoButton>
      </Flex>
    </Container>
  );
};

const Container = styled.div`
  padding: 40px;
  background-color: ${({ theme }) => theme.commonColor.white};
  border-radius: 20px;
  @media ${devices.tablet} {
    padding: 28px;
  }
`;

const Name = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  font-family: 'Regular';
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.751px;
  @media ${devices.tablet} {
    font-size: 12px;
  }
`;

const Title = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => theme.commonColor.pink004};
  font-family: 'NOTO';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 150% */
  letter-spacing: -0.72px;
  @media ${devices.tablet} {
    font-size: 16px;
  }
`;

const Content = styled.div`
  color: ${({ theme }) => theme.commonColor.gray005};
  font-family: 'Var';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 150% */
  letter-spacing: -0.751px;
  @media ${devices.tablet} {
    font-size: 12px;
  }
`;

const ReNewButton = styled.div`
  background-color: ${({ theme }) => theme.commonColor.pink004};
  color: ${({ theme }) => theme.commonColor.white};
  font-family: 'Regular';
  font-size: 15.028px;
  font-style: normal;
  font-weight: 700;
  line-height: 22.543px; /* 150% */
  letter-spacing: -0.751px;
  padding: 5px 10px;
  border-radius: 3.757px;
  @media ${devices.tablet} {
    padding: 4px 8px;
    border-radius: 3px;
    font-size: 12px;
  }
`;

const InfoButton = styled.div`
  padding: 5px 10px;
  border-radius: 3.757px;
  color: ${({ theme }) => theme.commonColor.gray005};
  background-color: ${({ theme }) => theme.commonColor.gray002};
  font-family: 'Regular';
  font-size: 15.028px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.543px; /* 150% */
  letter-spacing: -0.751px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 18px;
`;

export default DonationCard;
